export const isFree = ({
  includeTranslationForm,
  includeApostille,
}: {
  includeTranslationForm: boolean
  includeApostille: boolean
}): boolean => !includeTranslationForm && !includeApostille
